import { ConfirmDetailField } from '../confirmDetailField/ConfirmDetailField'

import {
  ConfirmAsideVariant,
  ConfirmLayout,
  ItemCard,
} from '../../../types/confirm/confirm'

type ConfirmItemRowProps = {
  item: ItemCard
  layout: ConfirmLayout
  localValues: Record<string, string>
  onDetailChange: (key: string, value: string) => void
}

export function ConfirmItemRow({
  item,
  layout,
  localValues,
  onDetailChange,
}: ConfirmItemRowProps) {
  const isDetails = layout === ConfirmLayout.DETAILS

  return (
    <div
      className={`sum-row confirm-sum-row${isDetails ? ' confirm-sum-row--details' : ''}`}
    >
      <div className="confirm-sum-row-main">
        <div className="what">{item.title}</div>
        {item.subtitle && <div className="when">{item.subtitle}</div>}
        {item.details?.map((detail, index) => (
          <ConfirmDetailField
            key={detail.key ?? `${detail.label}-${index}`}
            detail={detail}
            layout={item.detailsLayout ?? layout}
            value={
              detail.key
                ? (localValues[detail.key] ?? detail.value)
                : detail.value
            }
            onDetailChange={onDetailChange}
          />
        ))}
      </div>

      {!isDetails && item.aside && (
        <div className="confirm-sum-row-side">
          <div
            className={`price-label ${(item.asideVariant ?? ConfirmAsideVariant.PAID).toLowerCase()}`}
          >
            {item.aside}
          </div>
        </div>
      )}
    </div>
  )
}
